<script>
export default {
  components: {},
}
</script>

<template>
  <div class="row">
		<slot></slot>
  </div>
</template>
